function headerHeight() {
    document.documentElement.style.setProperty('--headerHeight', "".concat($('header').outerHeight(), "px"));
};

headerHeight();

setTimeout(function() {
    window.addEventListener('resize', headerHeight);
}, 250);